export default {
  update: 'centersGet',
}